import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	moreFeaturesButton: {
		id: 'tmp-feature-toggle.feature-popup-content.feature-toggle-group.more-features-button',
		defaultMessage: 'More features',
		description:
			'button inside the manage feature popup menu to redirect user to the feature details page',
	},
	moreViewsButton: {
		id: 'tmp-feature-toggle.feature-popup-content.feature-toggle-group.more-views-button',
		defaultMessage: 'More views',
		description:
			'button inside the manage views popup menu to redirect user to the feature details page',
	},
	// translation deafultMessage and description a direct copy of
	// jira/src/packages/navigation-apps/sidebar/common/src/ui/shortcuts/messages.tsx
	// to enable translation reuse
	addItem: {
		id: 'tmp-feature-toggle.feature-popup-content.feature-toggle-group.add-item',
		defaultMessage: 'Add shortcut',
		description: 'Add shortcut copy for the button',
	},
});
